<template>
  <div>
    <isHeader ref="isHeader" />
    <div ref="scrollBox" style="height: 100vh; overflow-y: auto; overflow-x: hidden">
      <commonTop :info="{
        title: 'AI医患语音互动服务平台',
        desc: '广泛应用于院内诊后疾病管理、院外健康干预、家庭医生签约随访，实现了对居民健康状况的移动化、标签化、智能化管理，帮助家庭医生团队自动获取签约居民的需求，提供连续、精准的医疗或健康服务，提供连续、精准的医疗或健康服务。',
      }" :img="require('@/assets/SmartFamilyDoc/banner.png')">
        <!-- 插槽 -->
        <!-- <button>在线咨询</button> -->
        <button @click="$store.commit('changeAppointModal', true)">
          预约体验
        </button>
      </commonTop>
      <!--  -->
      <isTab current="AI医患语音互动服务平台" :info="info" />
      <div class="tips"><span class="red">*</span> 以上信息仅为健康参考，不能代替医生专业诊断与治疗建议</div>
      <isFooter />
    </div>
  </div>
</template>

<script>
import isHeader from "@/components/header/index.vue";
import isFooter from "@/components/footer/index.vue";
import commonTop from "@/components/commonTop/index.vue";
import isTab from "@/components/ProductTab/tab.vue";
export default {
  name: "SmartFamilyDoc",
  data() {
    return {
      info: {
        
        partThrees: [
          {
            title: "人工智能外呼技术平台",
            sub: "",
            swiper: [],
            img: require("@/assets/SmartFamilyDoc/platform.jpg"),
            id:1
          },
          {
            title: "随访任务管理",
            sub: "",
            swiper: [],
            img: require("@/assets/SmartFamilyDoc/manage.jpg"),
            id:2
          },
          {
            title: "智能随访助手",
            sub: "",
            swiper: [],
            img: require("@/assets/SmartFamilyDoc/manage.jpg"),
            id:3
          },
        ]
      },
    };
  },
  mounted() {
    let that = this;
    this.$refs.scrollBox.addEventListener("scroll", function (e) {
      if (e.target.scrollTop > 80) {
        that.$refs.isHeader.setScrollBg(true);
      } else {
        that.$refs.isHeader.setScrollBg(false);
      }
    });
  },
  components: {
    commonTop,
    isHeader,
    isFooter,
    isTab,
  },
};
</script>

<style>
.tips{
  text-align: center;
  padding-bottom: 0.5rem;
  font-size: 0.2rem;
}
.red{
  color: red;
}
</style>
